
import { z } from "zod";

export const SowChangeTypeValues = ["elective", "existingQuote", "insuranceFinancialAdjustment", "lineItems", "newQuote", "panelCount", "supplement", "supplementAndElective"] as const;
export const SowChangeTypeSchema = /* @__PURE__ */ z.enum(SowChangeTypeValues);
export const SowChangeType: (typeof SowChangeTypeSchema)["enum"] = { "elective": "elective", "existingQuote": "existingQuote", "insuranceFinancialAdjustment": "insuranceFinancialAdjustment", "lineItems": "lineItems", "newQuote": "newQuote", "panelCount": "panelCount", "supplement": "supplement", "supplementAndElective": "supplementAndElective" };
export type SowChangeType = (typeof SowChangeTypeValues)[number];
export const SowChangeTypeDisplayNames = { "elective": "Elective",
"existingQuote": "Existing quote",
"insuranceFinancialAdjustment": "Insurance Financial Adjustment",
"lineItems": "Add Line Item",
"newQuote": "New quote",
"panelCount": "Solar panel count",
"supplement": "Supplement",
"supplementAndElective": "Supplement + Elective", } satisfies Record<SowChangeType, string>;
